
























































import {Vue, Component, Prop} from 'vue-property-decorator';
import RadioElement from '@/components/common/RadioElement.vue';
import ValidateInput from '@/components/common/input/ValidateInput.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
@Component({
  components: {RadioElement, ValidateInput, CompSelectBox}
})
export default class GroupInfo extends Vue {
  @Prop()
  private group!: any;
  @Prop()
  private mallNo!: number;
  @Prop()
  private mallName!: string;
  @Prop()
  private memberAccumulationUseYn!: boolean;

  // 그룹 번호
  private get hasGroupNo() {
  return this.group.no > 0; 
  };

  // 그룹 이름
  private onChangeName(name: string): void {
    this.$emit('changeDetailName', {name, type: 'info'});
  };

  // 그룹 적립금 혜택
  private reserveRateOptions = {
    name: 'reserveRate',
    type: 'dec',
    digits: 1,
    limit: 3,
    max: 100
  };
  private reserveRateErrFlg = '';

  private focus(elementKey: string) {
    (this.$refs[elementKey] as any).focus();
  };
}
